import { render, staticRenderFns } from "./SaleOrderEmailItem.vue?vue&type=template&id=757e1b2f&scoped=true&"
import script from "./SaleOrderEmailItem.vue?vue&type=script&lang=js&"
export * from "./SaleOrderEmailItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleOrderEmailItem.vue?vue&type=style&index=0&id=757e1b2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757e1b2f",
  null
  
)

export default component.exports